/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { cropStatusSchema } from '../enums/crop-status';

export const updateClipCropStatusBodySchema = z.object({
  cropStatus: cropStatusSchema,
  baseLocalPath: z.string().nullable().optional(),
  verticalLocalPath: z.string().nullable().optional(),
  basePath: z.string().nullable().optional(),
  verticalPath: z.string().nullable().optional(),
  durationMs: z.number().int().optional(),
  errorMessage: z.string().nullable().optional(),
  startMs: z.number().int().optional(),
  endMs: z.number().int().optional(),
  fileSizeKb: z.number().int().optional(),
});

export type IUpdateClipCropStatusBody = z.infer<typeof updateClipCropStatusBodySchema>;

export interface IUpdateClipCropStatusRequest {
  clipId: number;
  body: IUpdateClipCropStatusBody;
}
